// eslint-disable-next-line @typescript-eslint/no-unused-vars
import * as React from 'react';

const TITLE = 'YouTube';

interface YouTubeProps {
  className?: string;
}

export function YouTube({ className }: YouTubeProps) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label={TITLE}
      className={className}
    >
      <title>{TITLE}</title>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.9356 6.06695C21.2459 6.37724 21.4687 6.76306 21.5818 7.18581C22 8.74613 22 12 22 12C22 12 22 15.2539 21.5818 16.8142C21.4687 17.2369 21.2459 17.6228 20.9356 17.933C20.6253 18.2433 20.2384 18.4672 19.8136 18.5823C18.25 19 12 19 12 19C12 19 5.75 19 4.18636 18.5823C3.76161 18.4672 3.37472 18.2433 3.06441 17.933C2.7541 17.6228 2.53125 17.2369 2.41818 16.8142C2 15.2539 2 12 2 12C2 12 2 8.74613 2.41818 7.18581C2.53125 6.76306 2.7541 6.37724 3.06441 6.06695C3.37472 5.75666 3.76161 5.53279 4.18636 5.41774C5.75 5 12 5 12 5C12 5 18.25 5 19.8136 5.41774C20.2384 5.53279 20.6253 5.75666 20.9356 6.06695ZM15 12L10 15V9L15 12Z"
        fill="currentColor"
      />
    </svg>
  );
}
